module.exports = __webpack_public_path__ + "img/_54A6791.4596fc4d.jpg";